import { useWalletAlerts } from "@/hooks/platform/useWalletAlerts";

/** Mounts the real-time wallet credit alerts for the signed-in member. */
const WalletAlertsListener = () => {
  useWalletAlerts();
  return null;
};

export default WalletAlertsListener;
